import { AccountActionCreators } from 'actions/account';
import { AccountProfileStatus } from 'constants/account';
import { AccountState } from 'models/account';

export const initialState: AccountState = {
  account: {
    email: '',
    id: 0,
    phone: '',
    profile: {
      address: '',
      birthDate: '',
      birthPlace: '',
      motherName: '',
      name: '',
      nationalCardNumber: '',
      status: AccountProfileStatus.REJECTED,
      verifiedAt: ''
    },
    store: {
      avatar: '',
      storeAddress: '',
      storeName: '',
      storeUrl: ''
    },
    unverifiedEmail: ''
  },
  isAuthenticated: false,
  tempAccount: {
    email: '',
    password: '',
    phone: ''
  },
  tempAccountProfileForm: {
    address: '',
    birthDate: '',
    birthPlace: '',
    motherName: '',
    name: '',
    nationalCardNumber: ''
  }
};

type Action = typeof AccountActionCreators[keyof typeof AccountActionCreators];

export function accountReducer(state = initialState, action: Action): typeof initialState {
  switch (action.type) {
    case AccountActionCreators.updateTempAccount.type:
      return { ...state, tempAccount: action.payload };
    case AccountActionCreators.updateAccount.type:
      return { ...state, account: action.payload };
    case AccountActionCreators.updateTempAccountProfileForm.type:
      return { ...state, tempAccountProfileForm: action.payload };
    case AccountActionCreators.setIsAuthenticated.type:
      return { ...state, isAuthenticated: true };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/account.ts